type OwnProps = {
  id?: string;
  background?: React.ReactNode;
  header?: React.ReactNode;
  children?: React.ReactNode;
  footer?: React.ReactNode;
  selected?: boolean;
  disabled?: boolean;
  onClick?: $TSFixMeFunction;
};

const defaultProps: Partial<OwnProps> = {
  id: undefined,
  background: undefined,
  header: undefined,
  children: undefined,
  footer: undefined,
  selected: false,
  disabled: false,
  onClick: undefined,
};

type Props = OwnProps & typeof defaultProps;

function Tile({
  id,
  header,
  children,
  footer,
  selected,
  disabled,
  onClick,
  background,
}: Props) {
  const content = (
    <>
      <div className="tile-background">{background}</div>
      <div className="tile-header">{header}</div>
      <div className="tile-body">{children}</div>
      <div className="tile-footer">{footer}</div>
    </>
  );

  const className = `tile${selected ? " selected" : ""}`;
  return onClick ? (
    <button
      id={id}
      className={className}
      type="button"
      disabled={disabled}
      onClick={onClick}
    >
      {content}
    </button>
  ) : (
    <div id={id} className={className}>
      {content}
    </div>
  );
}

Tile.defaultProps = defaultProps;

export default Tile;
